import { Settings, Presentation } from "../../Settings";
import { ImageTransition } from "./ImageTransition";
import { ImgTransitionPIXI } from "./ImageTransitionPIXI";
import { ITransition } from "./ITransition";
import { ITransitionFactory, ITransitionParams, } from "./ITransitionFactory";
import { ITransitionFactoryPIXIAPP, ITransitionParamsPIXIAPP } from "./ITransitionFactoryPIXIAPP";
import { JackpotTransitionSpineFactory } from "./JackpotTransitionSpineAnimationResponsiveFactory";
import { TransitionAnimationSpine } from "./TransitionAnimationSpine";
import { TransitionAnimationSpineResponsive } from "./TransitionAnimationSpineResponsive";
import { VideoNoSpriteTransition } from "./VideoNoSpriteTransition";
import { VideoSpriteTransition } from "./VideoSpriteTransition";
import { VideoSpriteTransitionClassicMix } from "./VideoSpriteTransitionClassicMix";
import { TransitionPIXITypeStyle, VideoSpriteTransitionParticlesPIXIFadeInFadeOut } from "./VideoSpriteTransitionParticlesPIXIFadeInFadeOut";
import { VideoSpriteTransitionParticlesPIXIFadeInFadeOutResponsive } from "./VideoSpriteTransitionParticlesPIXIFadeInFadeOutResponsive";
import { VideoSpriteTransitionParticlesPIXiMatterJS } from "./VideoSpriteTransitionParticlesPIXiMatterJS";


const transitionFactoryMap: Record<TransitionPIXITypeStyle | Presentation, (params: ITransitionParamsPIXIAPP) => ITransition> = {
    [TransitionPIXITypeStyle.default]: (params: ITransitionParamsPIXIAPP) => new VideoSpriteTransitionParticlesPIXIFadeInFadeOutResponsive(params),
    [TransitionPIXITypeStyle.gameStyle]: (params: ITransitionParamsPIXIAPP) => new TransitionAnimationSpineResponsive(params),
    [TransitionPIXITypeStyle.imageStyle]: (params: ITransitionParamsPIXIAPP) => new ImgTransitionPIXI(params),
    [Presentation.JackpotTransitionSpineAnimationResponsive]: (params: ITransitionParamsPIXIAPP) => {
        const newJackpotTransition = new JackpotTransitionSpineFactory(params);
        return newJackpotTransition.CreateResponsiveTransition(params);
    },
    [Presentation.Image]: (params: ITransitionParamsPIXIAPP) => new ImgTransitionPIXI(params),
    [Presentation.VideoParticleTransitionFadeInFadeOut]: (params: ITransitionParamsPIXIAPP) => new VideoSpriteTransitionParticlesPIXIFadeInFadeOut(params),
    [Presentation.VideoParticleTransitionFadeInFadeOutResponsive]: (params: ITransitionParamsPIXIAPP) => new VideoSpriteTransitionParticlesPIXIFadeInFadeOutResponsive(params),
    [Presentation.VideoGameSprite]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [Presentation.VideoCommonNoSprite]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [Presentation.VideoCommonClassic]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [Presentation.VideoNoSprite]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [Presentation.VideoParticleTransitionMatterJS]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [TransitionPIXITypeStyle.settingsStyle]: (params: ITransitionParamsPIXIAPP) => {
        const tra: Presentation = Settings.PresentationType;
        return transitionFactoryMap[tra](params);
    }
};

export class TransitionFactoryPIXIAPP implements ITransitionFactoryPIXIAPP {
    
    CreatePIXIAPP(params: ITransitionParamsPIXIAPP): ITransition {
    
        let tra: TransitionPIXITypeStyle | Presentation = params?.transitionPIXITypeStyle ?? Settings.PresentationType;
        return transitionFactoryMap[tra](params);


        // if (params.transitionPIXITypeStyle == TransitionPIXITypeStyle.gameStyle) return new TransitionAnimationSpine(params);

        // return new VideoSpriteTransitionParticlesPIXIFadeInFadeOut(params);

    }
    CreatePIXIAPPResponsive(params: ITransitionParamsPIXIAPP): ITransition {

        if (Settings.Screens != 1) {
            throw new Error(`Can't create PIXIAPP Responsive with ${Settings.Screens} screens`);
        }

        let tra: TransitionPIXITypeStyle | Presentation = params?.transitionPIXITypeStyle ?? Settings.PresentationType;
        return transitionFactoryMap[tra](params);

        // if (tra == TransitionPIXITypeStyle.default || tra == Presentation.VideoParticleTransitionFadeInFadeOut)
        // {
        //     return new VideoSpriteTransitionParticlesPIXIFadeInFadeOutResponsive(params);
        // }
        // else if (tra == TransitionPIXITypeStyle.gameStyle)
        // {
        //     return new TransitionAnimationSpineResponsive(params);
        // }
        // else if (tra == TransitionPIXITypeStyle.imageStyle || tra == Presentation.Image)
        // {
        //     return new ImgTransitionPIXI(params);
        // }
        // else
        // {
        //     throw new Error(`Can't create PIXIAPP Responsive with ${params.transitionPIXITypeStyle}`);
        // }
    }
}


